module.exports = __webpack_public_path__ + "img/teacherResearch_sys.9b3cbd27.png";